




































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import IconItem2 from "@/zh-website/src/components/website/IconItem2.vue";
@Component({
  components: {
    IconItem2
  }
})
export default class Category extends Vue {
  iconList = [
    {
      img: require("../../../assets/Storage.svg"),
      name: "Storage"
    },
    {
      img: require("../../../assets/Collaboration.svg"),
      name: "Collaboration"
    },
    {
      img: require("../../../assets/Intelligent Vision.svg"),
      name: "Intelligent Vision"
    },
    {
      img: require("../../../assets/Digital Power.png"),
      name: "Digital Power"
    },
    { img: require("../../../assets/MDC.png"), name: "MDC" }
  ];
  iconList2 = [
    { img: require("../../../assets/Datacom.svg"), name: "Datacom" },
    {
      img: require("../../../assets/Routing & Switching.svg"),
      name: "Routing & Switching"
    },
    { img: require("../../../assets/Data Center.svg"), name: "Data Center" },
    { img: require("../../../assets/WLAN.svg"), name: "WLAN" },
    { img: require("../../../assets/Security.svg"), name: "Security" }
  ];
  iconList4 = [
    { img: require("../../../assets/Transmission.svg"), name: "Transmission" },
    { img: require("../../../assets/Access.svg"), name: "Access" },
    { img: require("../../../assets/5G.svg"), name: "5G" },
    { img: require("../../../assets/LTE.svg"), name: "LTE" }
  ];
  iconList3 = [
    { img: require("../../../assets/image/Cloud.png"), name: "Cloud" },
    { img: require("../../../assets/image/Big Data.png"), name: "Big Data" },
    { img: require("../../../assets/image/GaussDB.png"), name: "GaussDB" },
    { img: require("../../../assets/image/IoT.png"), name: "IoT" }
  ];
  iconList5 = [
    { img: require("../../../assets/image/openEuler.png"), name: "openEuler" },
    { img: require("../../../assets/image/openGauss.png"), name: "openGauss" },
    { img: require("../../../assets/image/HarmonyOS.png"), name: "HarmonyOS" },
    { img: require("../../../assets/image/AI.png"), name: "AI" },
    {
      img: require("../../../assets/image/Kunpeng Application Developer.png"),
      name: "Kunpeng Application Developer"
    }
  ];
  iconList6 = [
    {
      img: require("../../../assets/image/Kunpeng Computing.png"),
      name: "Kunpeng Computing"
    }
  ];
}
